import { RECHARGE_WALLET_FAILURE, RECHARGE_WALLET_REQUEST, RECHARGE_WALLET_RESET, RECHARGE_WALLET_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const rechargeWalletData = (state = initialState, action) => {
    switch (action.type) {
        case RECHARGE_WALLET_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case RECHARGE_WALLET_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case RECHARGE_WALLET_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case RECHARGE_WALLET_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: null, result: null });
        default:
            return state;
    }
};
export default rechargeWalletData;
